export function isNonNullObject(obj){return null!==obj&&"object"==typeof obj}